import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const SearchIcon = createSvgIcon(
 <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" fill="transparent" />
  <path
   fillRule="evenodd"
   clipRule="evenodd"
   d="M3.37165 14.823C6.47473 17.9261 11.4698 17.9841 14.6436 14.9971C14.6475 14.9934 14.6514 14.9897 14.6553 14.986L18.6 18.9307C18.6977 19.0283 18.8559 19.0283 18.9536 18.9307C19.0512 18.8331 19.0512 18.6748 18.9536 18.5771L15.0082 14.6318C17.984 11.4574 17.9222 6.47088 14.823 3.37166C11.6608 0.209448 6.53386 0.209448 3.37165 3.37166C0.209448 6.53386 0.209448 11.6608 3.37165 14.823ZM14.4695 3.72521C17.4364 6.69215 17.4364 11.5025 14.4695 14.4695C11.5025 17.4364 6.69215 17.4364 3.72521 14.4695C0.758264 11.5025 0.758264 6.69215 3.72521 3.72521C6.69215 0.758264 11.5025 0.758264 14.4695 3.72521Z"
   fill="currentColor"
  />
 </svg>,
 "Search"
);
